export const ALEATORY_DAY_IN_PAST = 'Jan 01 2020'; //This day is only for the first time the dialog is rendered.
